import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { AcercadeComponent } from './acercade.component';
import { KnowledgeBaseArticleComponent } from './article/article.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';

// SERVICIO AUTORIZACION E INTERCEPTION DE TOKEN
import { AuthGuard } from 'app/auth/auth.guard';
import {MatIconModule} from '@angular/material/icon';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';



const rutas: Routes = [
    // trust index
    {
        path     : 'about',
        component: AcercadeComponent,
        canActivate: [AuthGuard]
    }

];

@NgModule({
  declarations: [AcercadeComponent,
  KnowledgeBaseArticleComponent ],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    MatIconModule,
    TranslateModule,
    MatToolbarModule,
    MatTooltipModule,
    FlexLayoutModule 

  ],
  entryComponents: [
      KnowledgeBaseArticleComponent
  ]
})
export class AcercadeModule { }
